import { SURVEY_QUESTION_FIELDS_TO_MERGE } from './constants';

export const mergeExternalQuestionsWithSurvey = ({ externalQuestions, surveyQuestions }) => {
  if (!Array.isArray(externalQuestions)) return [];

  const surveyQuestionsBySourceId = new Map();
  (surveyQuestions || []).forEach((question) => {
    if (!question?.questionSourceId) return;
    surveyQuestionsBySourceId.set(String(question.questionSourceId), question);
  });

  return externalQuestions.map((externalQuestion) => {
    const match = surveyQuestionsBySourceId.get(String(externalQuestion.id));
    if (!match) return externalQuestion;

    const mergedFields = SURVEY_QUESTION_FIELDS_TO_MERGE.reduce((acc, field) => {
      if (match[field] !== undefined) acc[field] = match[field];
      return acc;
    }, {});

    return { ...externalQuestion, ...mergedFields };
  });
};
